import { Navigate, Outlet } from "react-router-dom";

export const VerifiedKyc = ({ isVerified = false}) => {
  return isVerified ? <Outlet /> : <Navigate replace to="./wait-verification" />;
};
export default VerifiedKyc;
